<script>
import Listpagination from './ListPagination';
import listtemplate from './ListTemplate';

export default {
    props: {
        name: {
            type: String,
            default: 'my-table'
        },
        // MUDANCA 1 (17/09/2026): quantos itens por pagina (quando informado, manda no que estiver salvo
        // no navegador) e o texto discreto de "Exibindo ...". Usado na lista de marcas da home.
        perPagePadrao: {
            type: Number,
            default: 0
        },
        textoExibindo: {
            type: String,
            default: ''
        },
        apiUrl: {
            type: String,
            default: ''
        },
        fields: {
            type: Array,
            default () {
                return [];
            }
        },
        useFilter: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: 'Shop Grid 03 Col'
        },
        corLoading: {
            type: String,
            default: '#000'
        },
        css: {
            type: Object,
            default () {
                return {
                    table: {
                        tableClass: 'table dataTable table-striped',
                        tableWrapper: '',
                        tableHeaderClass: 'thead-light',
                        tableBodyClass: 'table-striped',
                        loadingClass: 'loading',
                        ascendingIcon: '',
                        descendingIcon: '',
                        ascendingClass: 'sorting_asc',
                        descendingClass: 'sorting_desc',
                        sortableIcon: '',
                        handleIcon: ''
                    },
                    pagination: {
                        wrapperClass: 'pagination m--pull-left',
                        activeClass: 'active',
                        disabledClass: 'disabled',
                        pageClass: 'btn m-btn--pill btn-outline-primary border-0 page-class',
                        linkClass: 'btn m-btn--pill btn-outline-primary border-0 link-class',
                        icons: {
                            first: 'fa fa-angle-double-left',
                            prev: 'fa fa-angle-left',
                            next: 'fa fa-angle-right',
                            last: 'fa fa-angle-double-right'
                        }
                    }
                };
            }
        },
        showExtraFilters: {
            type: Boolean,
            default: false
        },
        appendParams: {
            type: Object,
            default () {
                return {};
            }
        },
        showPagination: {
            type: Boolean,
            default: true
        },
        showListViewType: {
            type: Boolean,
            default: true
        },
        customClass: {
            type: String,
            default: 'col-xl-9'
        },
        showTitle: {
            type: Boolean,
            default: true
        },
        customItemTitleClass: {
            type: String,
            default: 'custom-item-title'
        },
        fullLink: {
            type: Boolean,
            default: false
        }
    },
    components: {
        listtemplate,
        Listpagination,
        // 'filter-bar': FilterBar,
        // 'my-pagination': MyPagination,
        'stretch': VueLoadingSpinner.Stretch
    },
    data () {
        return {
            moreParams: {},
            perPage: this.$props.perPagePadrao
                ? this.$props.perPagePadrao
                : (localStorage.getItem(this.$props.name + '_perPage') ? localStorage.getItem(this.$props.name + '_perPage') : 21),
            exibindo: '',
            loadingString: 'Sem resultado'
        };
    },
    mounted () {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
    },
    watch: {
        perPage () {
            localStorage.setItem(this.$props.name + '_perPage', this.perPage);
            this.$nextTick(() => {
                this.$refs.vuetable.refresh();
            });
        }
    },
    render (createElement) {
        return createElement(
            'div',
            {
                attrs: {
                    'class': this.customClass
                }
            },
            [
                this.renderExibindo(createElement),
                createElement(
                    'div',
                    {
                    },
                    [
                        this.renderLoading(createElement),
                        this.renderVuetable(createElement)
                    ]
                ),
                this.renderPagination(createElement)
            ]
        );
    },
    methods: {
        onPaginationData (paginationData) {
            if (this.$parent.onPaginationData) {
                this.$parent.onPaginationData(paginationData);
            }
            // MUDANCA 2 (17/09/2026): aviso so' desta lista (a home usa para o "Exibindo x a y de z")
            this.$emit('pagination-data', paginationData);

            if (this.$refs.pagination) this.$refs.pagination.setPaginationData(paginationData);
            if (this.$refs.paginationInfo) this.$refs.paginationInfo.setPaginationData(paginationData);

            // MUDANCA 1: monta o texto "Exibindo x de y"
            if (this.$props.textoExibindo && paginationData) {
                const exibidos = (paginationData.to || 0) - (paginationData.from || 0) + 1;

                this.exibindo = this.$props.textoExibindo
                    .replace('{exibindo}', exibidos > 0 ? exibidos : 0)
                    .replace('{de}', paginationData.from || 0)
                    .replace('{ate}', paginationData.to || 0)
                    .replace('{total}', paginationData.total || 0);
            }
        },
        onChangePage (page) {
            this.noDataMessage = $(this.$refs.loadingSpinner).clone().removeClass('d-none').html();
            this.$refs.vuetable.changePage(page);
        },
        onFilterSet (filterText) {
            Object.assign(this.moreParams, {'filter': filterText});

            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onFilterReset () {
            this.$emit('clear-extra-fields');
            this.moreParams = {};
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        renderFilter (createElement) {
            if (!this.useFilter) {
                return;
            }
            return createElement('filter-bar', {
                ref: 'filter',
                props: {
                    showExtraFilters: this.$props.showExtraFilters
                },
                scopedSlots: this.$vnode.data.scopedSlots
            });
        },
        renderVuetable (createElement) {
            return createElement(
                'listtemplate',
                {
                    ref: 'vuetable',
                    props: {
                        loadOnStart: this.loadOnStart,
                        apiUrl: this.apiUrl,
                        fields: this.fields,
                        trackBy: this.trackBy,
                        css: this.css.table,
                        dataPath: this.dataPath,
                        paginationPath: '',
                        perPage: Number.parseInt(this.perPage),
                        sortOrder: this.sortOrder,
                        appendParams: this.appendParams,
                        apiMode: this.apiMode,
                        usePreload: this.usePreload,
                        httpFetch: this.httpFetch,
                        data: this.data,
                        tableHeight: this.tableHeight,
                        noDataTemplate: this.loadingString,
                        detailRowId: this.detailRowId,
                        detailRowTransition: 'expand',
                        detailRowComponent: this.detailRowComponent,
                        wrapperClass: 'vuetable-wrapper',
                        title: this.title,
                        showListViewType: this.showListViewType,
                        showTitle: this.showTitle,
                        customItemTitleClass: this.customItemTitleClass,
                        fullLink: this.fullLink
                    },
                    on: {
                        'vuetable:pagination-data': this.onPaginationData,
                        'vuetable:loading': this.showLoader,
                        'vuetable:loaded': this.hideLoader
                    },
                    scopedSlots: this.$vnode.data.scopedSlots
                }
            );
        },
        // MUDANCA 1: linha discreta com a quantidade exibida (so aparece se o texto for informado)
        renderExibindo (createElement) {
            if (!this.$props.textoExibindo || !this.exibindo) {
                return null;
            }

            return createElement('div', {
                attrs: {
                    class: 'custom-exibindo-info'
                }
            }, this.exibindo);
        },
        renderLoading (createElement) {
            return createElement('div', {
                ref: 'loadingSpinner',
                attrs: {
                    class: 'loading-spinner-container d-none'
                }
            }, [createElement('div', {
                attrs: {
                    class: 'd-inline-block'
                }
            }, [createElement('stretch', {attrs: {background: this.corLoading} })])]);
        },
        renderPagination (createElement) {
            return createElement('Listpagination', {
                ref: 'pagination',
                props: {
                    infoTemplate: 'Mostrando {from} - {to} de {total}',
                    noDataTemplate: 'Sem resultado',
                    showPagination: this.showPagination
                },
                on: {
                    'vuetable-pagination:change-page': this.onChangePage
                }
            });
        },
        showLoader () {
            this.loadingString = $(this.$refs.loadingSpinner).clone().removeClass('d-none').html();
            this.$refs.vuetable.tableData = [];
        },
        hideLoader () {
            this.loadingString = 'Sem resultado';
        }
    }
};
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
</style>
